<template>
  <component :is="tag" class="header-text" v-bind="$attrs" v-on="$listeners">
    <slot />
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  font-size: 28px;
  font-weight: 500;
  line-height: 1.1em;
  font-weight: 600;

  @media screen and (min-width: 768px) {
    font-size: 36px;
  }
}
</style>
